<template>
  <section id="wrapper">
    <img src="@/assets/band2025.jpg" id="photo" />
  </section>
</template>

<style scoped>
#wrapper {
  line-height: 0;
  position: relative;
  z-index: 2;
  background-color: #f1feff;
}
#photo {
  width: 100%;
}
</style>
